import { objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { randomId } from '@mantine/hooks';
import { Text } from '@mantine/core';
import { Divider } from '../../Divider/Divider.js';
import useStyles from './SelectItems.styles.js';

function SelectItems(_ref) {
  var data = _ref.data,
    hovered = _ref.hovered,
    classNames = _ref.classNames,
    styles = _ref.styles,
    isItemSelected = _ref.isItemSelected,
    uuid = _ref.uuid,
    __staticSelector = _ref.__staticSelector,
    onItemHover = _ref.onItemHover,
    onItemSelect = _ref.onItemSelect,
    itemsRefs = _ref.itemsRefs,
    Item = _ref.itemComponent,
    ItemWrapper = _ref.itemWrapperComponent,
    size = _ref.size,
    nothingFound = _ref.nothingFound,
    creatable = _ref.creatable,
    createLabel = _ref.createLabel,
    unstyled = _ref.unstyled;
  var _useStyles = useStyles({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      name: __staticSelector
    }),
    classes = _useStyles.classes;
  var unGroupedItems = [];
  var groupedItems = [];
  var creatableDataIndex = null;
  var constructItemComponent = function constructItemComponent(item, index) {
    var selected = typeof isItemSelected === 'function' ? isItemSelected(item.value) : false;
    return /*#__PURE__*/React__default.createElement(Item, _objectSpread2({
      key: item.value,
      className: classes.item,
      "data-disabled": item.disabled || undefined,
      "data-hovered": !item.disabled && hovered === index || undefined,
      "data-selected": !item.disabled && selected || undefined,
      selected: selected,
      onMouseEnter: function onMouseEnter() {
        return onItemHover(index);
      },
      id: "".concat(uuid, "-").concat(index),
      role: "option",
      tabIndex: -1,
      "aria-selected": hovered === index,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[item.value] = node;
        }
      },
      onMouseDown: !item.disabled ? function (event) {
        event.preventDefault();
        onItemSelect(item);
      } : null,
      disabled: item.disabled
    }, item));
  };
  var groupName = null;
  data.forEach(function (item, index) {
    if (item.creatable) {
      creatableDataIndex = index;
    } else if (!item.group) {
      unGroupedItems.push(constructItemComponent(item, index));
    } else {
      if (groupName !== item.group) {
        groupName = item.group;
        groupedItems.push( /*#__PURE__*/React__default.createElement("div", {
          className: classes.separator,
          key: "__mantine-divider-".concat(index)
        }, /*#__PURE__*/React__default.createElement(Divider, {
          classNames: {
            label: classes.separatorLabel
          },
          label: item.group
        })));
      }
      groupedItems.push(constructItemComponent(item, index));
    }
  });
  if (creatable) {
    var creatableDataItem = data[creatableDataIndex];
    unGroupedItems.push( /*#__PURE__*/React__default.createElement("div", {
      key: randomId(),
      className: classes.item,
      "data-hovered": hovered === creatableDataIndex || undefined,
      onMouseEnter: function onMouseEnter() {
        return onItemHover(creatableDataIndex);
      },
      onMouseDown: function onMouseDown(event) {
        event.preventDefault();
        onItemSelect(creatableDataItem);
      },
      tabIndex: -1,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[creatableDataItem.value] = node;
        }
      }
    }, createLabel));
  }
  if (groupedItems.length > 0 && unGroupedItems.length > 0) {
    unGroupedItems.unshift( /*#__PURE__*/React__default.createElement("div", {
      className: classes.separator,
      key: "empty-group-separator"
    }, /*#__PURE__*/React__default.createElement(Divider, null)));
  }
  return groupedItems.length > 0 || unGroupedItems.length > 0 ? ItemWrapper ? ( /*#__PURE__*/React__default.createElement(ItemWrapper, null, groupedItems, unGroupedItems)) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, groupedItems, unGroupedItems)) : ( /*#__PURE__*/React__default.createElement(Text, {
    size: size,
    unstyled: unstyled,
    className: classes.nothingFound
  }, nothingFound));
}

export { SelectItems };
//# sourceMappingURL=SelectItems.js.map
